import { render, staticRenderFns } from "./SvgTextModal.vue?vue&type=template&id=38543a7e&scoped=true"
import script from "./SvgTextModal.vue?vue&type=script&lang=js"
export * from "./SvgTextModal.vue?vue&type=script&lang=js"
import style0 from "./SvgTextModal.vue?vue&type=style&index=0&id=38543a7e&prod&scoped=true&lang=css"
import style1 from "./SvgTextModal.vue?vue&type=style&index=1&id=38543a7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38543a7e",
  null
  
)

export default component.exports